import { render, staticRenderFns } from "./InfoBoxHorizontal.vue?vue&type=template&id=c0ce6a4c&scoped=true&"
import script from "./InfoBoxHorizontal.vue?vue&type=script&lang=ts&"
export * from "./InfoBoxHorizontal.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBoxHorizontal.vue?vue&type=style&index=0&id=c0ce6a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ce6a4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow})
